import styled from "styled-components";

export const SalesDatatableWrapper = styled.div`
  height: 66vh;
  overflow: auto;
`